// extracted by mini-css-extract-plugin
export default {"chart":"trendByPortfolio_chart__6QgtB","pdb4":"trendByPortfolio_pdb4__UWHOd","table":"trendByPortfolio_table__XaWxp"};